import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { defaultRouteRule, privilegeRouteRule } from '../config/config';
import { userType, userPrivilege } from 'const/nuclias/user';
import { PATH } from "router/config/const";
import { isNil } from "lodash";

const PrivateRouter = ({ children }) => {
  const user = useSelector(state => state.user.user);
  let currentPath = window.location.pathname.toLowerCase();
  const arr = currentPath.split('/')
  if (arr[arr.length - 1] === '') {
    currentPath = currentPath.substring(0, currentPath.length - 1)
    let href = window.location.href
    window.history.replaceState({}, null, href.substring(0, href.length - 1))
  }

  const createUrlPattern = (url) => {
    let idx = url.indexOf(":");
    while (idx > 0) {
      let replaceEnd = url.indexOf("/", idx);
      if (replaceEnd > 0)
        url = url.substring(0, idx) + "\\d+" + url.substring(replaceEnd);
      else
        url = url.substring(0, idx) + "\\d+";
      idx = url.indexOf(":");
    }
    return "^" + url.replace(new RegExp("/", "g"), "\\/") + "$";
  };

  const checkPrivilege = () => {
    if (isNil(user)) { return false; }
    if (user.type === userType.cloudAdmin) { return true; }

    let headerCtrlResult = false; // sp, si ...
    const headerCtrl = defaultRouteRule[user.type];
    for (const [url] of Object.entries(headerCtrl)) {
      const urlPattern = createUrlPattern(url).toLowerCase();
      if (currentPath.match(urlPattern)) {
        headerCtrlResult = true;
        break;
      }
    }

    let privilegeCtrlResult = false; // editor, monitor ...
    if (user.privilege !== userPrivilege.manager) {
      const privilegeCtrl = privilegeRouteRule[user.privilege];
      for (const url of privilegeCtrl) {
        const urlPattern = createUrlPattern(url).toLowerCase();
        if (currentPath.match(urlPattern)) {
          privilegeCtrlResult = true;
          break;
        }
      }
    } else {
      privilegeCtrlResult = true;
    }

    return headerCtrlResult && privilegeCtrlResult;
  };

  const userDefaultRedirect = () => {
    if (user.type === userType.cloudAdmin) {
      return '/admin/dashboard'
    } else if (user.type === userType.sp) {
      return PATH.settings.organization
    } else {
      return PATH.dashboard.dashboard
    }
  }

  const auth = checkPrivilege();
  // console.log('currentPath', currentPath, auth)
  return auth ? children : <Navigate to={userDefaultRedirect()} replace />;
};

export default PrivateRouter;